import React, { useEffect, useState } from 'react';

export default function GalaxyGateMinimal({
  liveCount,
  unique24h,
  uniqueAllTime,
  lastArrivals,
}) {
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    if (!lastArrivals?.length) return;
    setPulse(true);
    const id = setTimeout(() => setPulse(false), 400);
    return () => clearTimeout(id);
  }, [lastArrivals]);

  return (
    <div
      className="gg-minimal"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '6px 12px',
        borderRadius: 999,
        background: '#0b1021',
        color: '#e9f2ff',
        border: '1px solid rgba(255,255,255,0.1)',
        boxShadow: pulse
          ? '0 0 0 6px rgba(77, 171, 255, 0.15)'
          : '0 3px 10px rgba(0,0,0,0.25)',
        transition: 'box-shadow 200ms ease',
        minHeight: 32,
      }}
      title={`24h: ${unique24h} | All-time: ${uniqueAllTime}`}
    >
      <span
        style={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          background: '#51ff9c',
          boxShadow: pulse ? '0 0 8px 4px rgba(81,255,156,0.35)' : 'none',
          flexShrink: 0,
          transition: 'box-shadow 200ms ease',
        }}
      />
      <span style={{ fontWeight: 700, letterSpacing: 0.2 }}>Visitors</span>
      <span style={{ fontWeight: 700 }}>{liveCount ?? 0}</span>
      <span style={{ fontSize: 12, opacity: 0.75 }}>at the Gate</span>
    </div>
  );
}
